<template>
	<div
		class="the-navbar__user-meta flex items-center"
		v-if="activeUserInfo.displayName"
		:style="{color: $store.state.moduleSetting.navbarColor === '#fff' ? '#626262' : 'white'}"
	>
		<div class="text-right leading-tight hidden sm:block">
			<p class="font-semibold">{{ activeUserInfo.name | capitalize }}</p>
			<small v-if="resource_data">{{ resource_data.alias }}</small>
			<small v-else>{{ activeUserInfo.serviroutes_role_name }}</small>
		</div>

		<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
			<div class="con-img ml-3">
				<img
					v-if="activeUserInfo.photoURL"
					key="onlineImg"
					:src="avatar"
					alt="user-img"
					width="40"
					height="40"
					class="rounded-full shadow-md cursor-pointer block"
				/>
			</div>

			<vs-dropdown-menu class="vx-navbar-dropdown">
				<ul style="min-width: 11rem">
					<li
						class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="
							$router
								.push(`/apps/resource/resource-view/${activeUserInfo.serviroutes_id}`)
								.catch(() => {})
						"
					>
						<feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">{{ $t("Profile") }}</span>
					</li>

					<li
						class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="$router.push('/dashboard/preferences').catch(() => {})"
					>
						<feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">{{ $t("Preferences.Preferences") }}</span>
					</li>
					<vs-divider class="m-1" />
					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
						<feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">{{ $t("LogOut") }}</span>
					</li>
				</ul>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import Api from "@/helpers/api.js";
import User from "@/models/User.js";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

// Store Module
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	data() {
		return {
			avatar: require("@/assets/images/portrait/small/user-avatar.png"),
			user: new User(),
			resource_data: null,
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async getResourceInfo() {
			const userSession = await this.user.getUser();
			const userId = parseInt(userSession.serviroutes_id);
			const dataFilter = {
				ids: [userId],
				fields: [
					"alias",
					"company_id",
					"company_name",
					"email",
					"id",
					"identification",
					"imei",
					"img_url",
					"lastname",
					"name",
					"positionrecord_id",
					"role_id",
					"role_name",
					"uid",
					"username",
				],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
				.then((res) => {
					this.resource_data = res.data.records[0];
					this.getResourcePhoto(this.resource_data.img_url);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getResourcePhoto(img_url) {
			const url = img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		logout() {
			const firebaseCurrentUser = firebase.auth().currentUser;
			if (firebaseCurrentUser) {
				firebase
					.auth()
					.signOut()
					.then(() => {});
			}
			// If JWT login
			if (localStorage.getItem("accessToken")) {
				this.openLoading();
				Api.delete("/auth/sessions/".concat(this.$store.state.AppActiveUser.access_token))
					.then((res) => {
						this.closeLoading();
						localStorage.removeItem("accessToken");
						// Change role on logout. Same value as initialRole of acj.js
						this.$acl.change("editor");
						localStorage.removeItem("userInfo");
						this.$router.push("/pages/login").catch(() => {});
						const user = new User();
						user.deleteUserIndexed().then((res) => {});
					})
					.catch((err) => {
						this.closeLoading();
						console.error(err);
						localStorage.removeItem("accessToken");
						// Change role on logout. Same value as initialRole of acj.js
						this.$acl.change("editor");
						localStorage.removeItem("userInfo");
						this.$router.push("/pages/login").catch(() => {});
					});
			}

			// This is just for demo Purpose. If user clicks on logout -> redirect
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		this.getResourceInfo();
	},
};
</script>
